import { disciplineByKey } from 'constants/disciplines';
import Immutable from 'immutable';

type DisciplineKeys = Extract<keyof typeof disciplineByKey, string>;

export interface RawMappedSheetQuery {
  sortField: string; // would be nice to have this as an enum.
  sortDirection: 'ascending' | 'descending';
  search: string;
  disciplines: DisciplineKeys[];
  disciplineSearch: string;
}

export interface MappedSheetQueryData {
  sortField: string;
  sortDirection: 'ascending' | 'descending';
  search: string;
  disciplines: Immutable.Set<DisciplineKeys>;
  disciplineSearch: string;
}

export const defaultValues: MappedSheetQueryData = {
  sortField: 'creationDate',
  sortDirection: 'descending',
  search: '',
  disciplines: Immutable.Set<DisciplineKeys>(),
  disciplineSearch: '',
};

export const MappedSheetQueryFactory = Immutable.Record(
  defaultValues,
  'MappedSheetQuery'
);

export class MappedSheetQuery extends MappedSheetQueryFactory {
  static deserialize(rawSheetQuery: RawMappedSheetQuery): MappedSheetQuery {
    return new MappedSheetQuery({
      ...rawSheetQuery,
      disciplines: Immutable.Set(rawSheetQuery.disciplines),
    });
  }

  serialize(): RawMappedSheetQuery {
    return this.toJS();
  }
}
